import React, { ReactElement } from 'react';

import { Icon } from '@epoch-ui/components/Icon';
import { SquareCheckIcon } from 'components/common/icons/SquareCheckIcon';
import { RadioIcon } from 'components/common/icons/RadioIcon';
import { SurveyQuestionAnswerIcon } from 'components/common/icons/SurveyQuestionAnswerIcon';
import IntegrationsIcon from 'components/common/icons/IntegrationsIcon';
import RefreshIcon from 'components/common/icons/RefreshIcon';
import { QUESTION_TYPE } from 'types/question.types';
import { DARK_BLACK } from 'constants/colours';

export interface QuestionTypeOption {
  type: QUESTION_TYPE;
  label: string;
  icon: ReactElement;
}

export const customQuestionTypes: QuestionTypeOption[] = [
  {
    type: QUESTION_TYPE.LONG,
    label: 'Long answer',
    icon: React.createElement(Icon, { name: 'align-left' })
  },
  {
    type: QUESTION_TYPE.RADIO,
    label: 'Single choice',
    icon: React.createElement(RadioIcon)
  },
  {
    type: QUESTION_TYPE.CHECK,
    label: 'Multiple choice',
    icon: React.createElement(SquareCheckIcon, { className: 'rounded tw-bg-dark-black' })
  },
  {
    type: QUESTION_TYPE.LINEAR_SCALE,
    label: 'Linear scale',
    icon: React.createElement(Icon, { name: 'bar-chart-2' })
  }
];

export const engagementMetricTypes: QuestionTypeOption[] = [
  {
    type: QUESTION_TYPE.NPS,
    label: 'Net Promoter Score®',
    icon: React.createElement(SurveyQuestionAnswerIcon, { width: '24', height: '24' })
  },
  {
    type: QUESTION_TYPE.SATISFACTION,
    label: 'Satisfaction score',
    icon: React.createElement(Icon, { name: 'heart' })
  },
  {
    type: QUESTION_TYPE.CONNECTION,
    label: 'Connection score',
    icon: React.createElement(IntegrationsIcon, { color: DARK_BLACK })
  },
  {
    type: QUESTION_TYPE.RETENTION,
    label: 'Retention score',
    icon: React.createElement(RefreshIcon)
  }
];
